import { httpRequest } from "@services/http";
import type { Feature } from "./cmdCreateFeature";

export class CommandListFeatures {
  async run(): Promise<Feature[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/permissions/features/`;
    try {
      return await httpRequest<Feature[]>(url, { method: "GET" });
    } catch (error) {
      console.error("Error fetching features:", error);
      throw error;
    }
  }
}
